import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import "./polyfill";
import React from "react";
import { createRoot } from "react-dom/client"; // <-- nouveau import
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { icons } from "./assets/icons";

import { Provider } from "react-redux";
import storeConfig from "./store/config-store";
import './index.css';

React.icons = icons;

const store = storeConfig();

const container = document.getElementById("root");
const root = createRoot(container); // <-- nouveau root React 18
root.render(
  <Provider store={store}>
    <App/>
  </Provider>
);

serviceWorker.unregister();
